var map = {
	"./calphalon.png": 2380,
	"./cuisinart.png": 2381,
	"./kitchenaid.png": 2382,
	"./lecreuset.png": 2383,
	"./libbey.png": 2384,
	"./oxo.png": 2385
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2837;



/*****************
 ** WEBPACK FOOTER
 ** ./public/images/registry/aboutZolaBrands nonrecursive \.(jpg|jpeg|png|gif|svg)(\?.*)?$
 ** module id = 2837
 ** module chunks = 44
 **/